import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { InputBase, styled } from '@mui/material'
import { SearchIcon } from '../../../eid-icons'
import { useDebounce } from '../../../core'

const SearchGeneric = styled('div')(({ theme, borderColor, bgColor }) => ({
    width: '100%',
    height: '4rem',
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    borderRadius: 3,
    margin: 'auto',
    border: `1px solid ${borderColor}`,
    backgroundColor: bgColor,
}))

const SearchIconWrapper = styled('div')({
    width: '1.8rem',
    height: '1.8rem',
    marginLeft: '1.3rem',
    marginTop: '0.2rem',

    '& > svg': {
        width: '100%',
        height: '100%',
    },
})

const StyledInputBase = styled(InputBase)(({ theme, color, hoverColor }) => ({
    marginLeft: '0.8rem',
    fontSize: '1.5rem',
    flex: 1,
    color: `${color} !important`,
    '&:hover, &:focus': {
        color: `${hoverColor} !important`,
    },
}))

function Search({ handleSearch, styleData, placeholder, value }) {
    const [searchKey, setSearchKey] = useState(value)

    useEffect(() => {
        if (value !== searchKey) {
            setSearchKey(value)
        }
    }, [value])

    const handleChange = (event) => {
        const keyword = event.target.value
        setSearchKey(keyword)
    }

    const debouncedValue = useDebounce(searchKey)
    useEffect(() => {
        handleSearch(debouncedValue)
    }, [debouncedValue, handleSearch])

    return (
        <SearchGeneric
            borderColor={styleData.borderColor}
            bgColor={styleData.bgColor}
        >
            <SearchIconWrapper>
                <SearchIcon color={styleData.iconColor} />
            </SearchIconWrapper>
            <StyledInputBase
                fullWidth={true}
                value={searchKey}
                onChange={handleChange}
                color={styleData.color}
                hoverColor={styleData.hoverColor}
                placeholder={placeholder ?? 'Search'}
            />
        </SearchGeneric>
    )
}

Search.propTypes = {
    handleSearch: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
}

Search.defaultProps = {
    handleSearch: () => {},
    value: '',
}

export default Search
